const API_KEY = process.env.VUE_APP_GOOGLE_API_KEY
const CALLBACK_NAME = 'gmapsCallback'
const LANGUAGE = window.translationParams?.language || 'ua'
const REGION = LANGUAGE.toUpperCase()

let initialized = !!window.google?.maps
let resolveInitPromise
let rejectInitPromise
const initPromise = new Promise((resolve, reject) => {
  resolveInitPromise = resolve
  rejectInitPromise = reject
})

export default function init () {
  if (initialized) return initPromise

  initialized = true
  window[CALLBACK_NAME] = () => resolveInitPromise(window.google)

  const script = document.createElement('script')
  script.async = true
  script.defer = true
  script.src = `https://maps.googleapis.com/maps/api/js?key=${API_KEY}&region=${REGION}&language=${LANGUAGE}&callback=${CALLBACK_NAME}&loading=async&v=3.59&libraries=geometry,places,marker`
  script.onerror = rejectInitPromise
  document.querySelector('head').appendChild(script)
  return initPromise
}
